import React from 'react';
import '../app.css';
import images from "./images";

export default () => {
    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        <div className="sidebar">
            <div className="description">
                <span className='description-label'><u>Object Storage</u></span>
            </div>
            <div className="dndnode" onDragStart={(event) => onDragStart(event, 'S3')} draggable>
                AWS Simple Storage Service (S3)
                <img
                    src={images.S3Logo}
                    height="20px"
                    style={{ margin: 5 }}
                />
            </div>
            <div className="dndnode" onDragStart={(event) => onDragStart(event, 'GCS')} draggable>
                Google Cloud Storage
                <img
                    src={images.GoogleObjStore}
                    height="20px"
                    style={{ margin: 3 }}
                />
            </div>
            <div className="dndnode" onDragStart={(event) => onDragStart(event, 'AZURE')} draggable>
                Azure Blob Storage
                <img
                    src={images.AzureBlobStore}
                    height="20px"
                    style={{ margin: 3 }}
                />
            </div>
            <div className="dndnode" onDragStart={(event) => onDragStart(event, 'minio')} draggable>
                Minio
                <img
                    src={images.MinioLogo}
                    height="20px"
                    style={{ margin: 3 }}
                />
            </div>
        </div>
    );
};
